var _excluded = ["children", "variant"];

var _templateObject, _templateObject2, _templateObject3;

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { css } from 'styled-components';
import { node, oneOf } from 'prop-types';
export var PLAN_LINE_HEIGHT = 8;
var Plan = styled.article(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-width: 312px;\n\n  overflow: hidden;\n\n  ", "\n"])), function (props) {
  var theme = props.theme.yoga;
  var plan = theme.components.card.plan;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      padding: ", "px ", "px\n        ", "px ", "px;\n      border: ", "px solid ", ";\n      border-radius: ", "px;\n\n      background-color: ", ";\n    "])), plan.padding.top, plan.padding.right, plan.padding.bottom, plan.padding.left, theme.borders.small, theme.colors.light, plan.radius, theme.colors.white);
});
var Border = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: inline-block;\n  width: 100%;\n\n  height: ", "px;\n  background-color: ", ";\n"])), PLAN_LINE_HEIGHT, function (_ref) {
  var variant = _ref.variant,
      _ref$theme$yoga$color = _ref.theme.yoga.colors,
      deepPurple = _ref$theme$yoga$color.deepPurple,
      _ref$theme$yoga$color2 = _ref$theme$yoga$color[variant],
      color = _ref$theme$yoga$color2 === void 0 ? deepPurple : _ref$theme$yoga$color2;
  return color;
});

var PlanCard = function PlanCard(_ref2) {
  var children = _ref2.children,
      variant = _ref2.variant,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Plan, rest, /*#__PURE__*/React.createElement(Border, {
    variant: variant
  }), children);
};

PlanCard.propTypes = {
  children: node,

  /** style the card border top color following the theme (primary, secondary,
   * vibin, hope, energy, relax, peace, verve, uplift, deepPurple, deep,
   * stamina, dark, medium, light, clear, white) */
  variant: oneOf(['primary', 'secondary', 'vibin', 'hope', 'energy', 'relax', 'peace', 'verve', 'uplift', 'deepPurple', 'stamina', 'dark', 'medium', 'deep', 'light', 'clear', 'white'])
};
PlanCard.defaultProps = {
  children: undefined,
  variant: 'deepPurple'
};
PlanCard.displayName = 'PlanCard';
export default PlanCard;